import React from 'react';

const statuses = {
    'ACTIVE': {
        text: 'Ativo',
        color: 'success'
    },
    'INACTIVE': {
        text: 'Bloqueado',
        color: 'danger'
    },
    'CANCELED': {
        text: 'Cancelado',
        color: 'default'
    },
    'UNKOWN': {
        text: 'Desconhecido',
        color: 'dark'
    }
}

const StatusBadge = ({ status }) => {
    let key = 'INACTIVE';
    if (status) {
        key = 'ACTIVE';
    }
    const st = statuses[key] || statuses['UNKOWN']; 
    return (
        <span className={`badge badge-${st.color} mr-4`}>{st.text}</span>
    );
}

export default StatusBadge;


// WEBPACK FOOTER //
// ./src/components/Pages/Establishments/StatusBadge.js